import CVProfileInformation from "../../../../../components/CVprofileInformation";

const CVInformation = ({cvdata}) => {
    return (
        <div>
            <CVProfileInformation header="text-white" title="title-margin" desc="desc-margin"cvdata={cvdata} />
        </div>
    )
}
export default CVInformation;